import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FilterInputCheckbox from "./FilterInputCheckbox";
import FilterInputSearch from "./FilterInputSearch";
import {
  updateFilter,
  fetchFilters,
  resetFilterGroup,
} from "../../redux/filters/filterSlice";
import { setCurrentPage } from "../../redux/pagination/paginationSlice";

function FilterGroup({ filterGroup }) {
  const isKidsSearchTerm = filterGroup.tableName === "KIDS.SearchTerm";
  const [isCollapsed, toggleCollapsed] = useState(false);
  const dispatch = useDispatch();
  const dictionary = useSelector((state) => state.localization.dictionary);

  function onFilterChange(filter) {
    onUpdateFilter(filter);
    dispatch(setCurrentPage(1));
    dispatch(fetchFilters());
  }

  function onUpdateFilter(filter) {
    dispatch(
      updateFilter({
        groupName: filterGroup.name,
        filter,
      })
    );
  }

  function onClearAllClick(evt) {
    evt.preventDefault();
    dispatch(setCurrentPage(1));
    
    dispatch(
      resetFilterGroup({
        groupName: filterGroup.name,
      })
    );
    dispatch(fetchFilters());
  }

  function onFilterLegendKeyUp(evt) {
    evt.stopPropagation();
    if (evt.keyCode === 13) {
      toggleCollapsed(!isCollapsed);
    }
  }

  return (
    <div className="filter-block">
      <fieldset className={`fieldset tags ${isCollapsed ? "collapsed" : ""}`}>
        <legend
          onClick={() => toggleCollapsed(!isCollapsed)}
          onKeyDown={(evt) => {
            onFilterLegendKeyUp(evt)
          }}
          tabIndex="0"
          className={`filter-${filterGroup.name}`}
        >
          {filterGroup.displayName}
          <span
            role="button"
            className="toggle"
            aria-label="Toggle filter group visibility"
          ></span>
        </legend>
        <span className="reset">
          <a href="#" onClick={onClearAllClick}>
            {dictionary["CNHS.Filter.ClearAll"]}
          </a>
        </span>
        {filterGroup.filters.map((filter, index) => {
          return isKidsSearchTerm ? (
            <FilterInputSearch
              filter={filter}
              key={`${filterGroup.displayName}-filter-${index}`}
              onSubmit={onFilterChange}
              onUpdate={onUpdateFilter}
            />
          ) : (
            <FilterInputCheckbox
              filter={filter}
              key={`${filterGroup.displayName}-filter-${index}`}
              onChange={onFilterChange}
            />
          );
        })}
      </fieldset>
    </div>
  );
}

export default FilterGroup;
